import __request__ from "routing/request";
export function single(limit, offset, requestOptions) {
  return __request__("GET", "/system/indexer/failures", null, { "limit": limit, "offset": offset }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function count(since, requestOptions) {
  return __request__("GET", "/system/indexer/failures/count", null, { "since": since }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
